import { AUTH } from "../actions/types";

const initialState = {
	authenticated: "",
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case AUTH:
			return state;

		default:
			return state;
	}
};

export default reducer;
